import Grid from '@mui/material/Grid';
import MoreHorizIcon from '@mui/icons-material/MoreHoriz';
import React, { memo, useContext } from 'react';
import { ActionCellStyles } from 'BaseComponents/HDataTable/utils/styles';
import { CellShadowStyles } from 'BaseComponents/HDataTable/CellShadowStyles';
import { DataContext } from 'BaseComponents/HDataTable/DataContextProvider';
import { DropdownMenu } from 'BaseComponents/DropdownMenu';
import { ResizableContext } from 'BaseComponents/HDataTable/ResizableContextProvider';
import { styled } from '@mui/material/styles';


const StyledTd = styled('td')({
  ...ActionCellStyles(),
  textAlign: 'left',
  '& .shadow': {
    ...CellShadowStyles,
  },
});

const StyledActionGrid = styled(Grid)({
  display: 'flex',
  alignItems: 'center',
  gap: '16px',
});

export const HActionCell = memo(({ row }) => {
  const { isTableFullSize, tableBodyElement } = useContext(ResizableContext);

  const { actionMenu, actionButton: ActionButton } = useContext(DataContext);

  if (!actionMenu && !ActionButton) return null;

  return (
    <>
      <StyledTd>
        <StyledActionGrid>
          {isTableFullSize && <div className='shadow' />}

          {ActionButton && <ActionButton row={row} />}

          {actionMenu && <DropdownMenu placement='bottom' icon={<MoreHorizIcon />} menuItems={actionMenu(row)} htmlContainerEl={tableBodyElement.current} />}
        </StyledActionGrid>
      </StyledTd>
      {!isTableFullSize && <td />}
    </>
  );
});

HActionCell.displayName = 'HActionCell';
